module.exports = __webpack_public_path__ + "media/images/notifications/icon_not_1-2e3e8e8c79c94c62a82437b0e90bea07.svg";